export const isDevelopmentMode = process?.env?.NODE_ENV?.toLocaleLowerCase() === 'development';
